export default __webpack_public_path__ + "static/media/bar.296e27e0.jpg";